import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-header-contactus',
    templateUrl: './header-contactus.component.html',
    styleUrl: './header-contactus.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderContactusComponent implements OnInit {

  public componentData$: Observable<CmsLinkComponent>;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.componentData$ = this.component.data$;
  }
}